// @flow

import styled from 'styled-components';
import colors from 'styles/colors';

const NotifCourriel = styled.div``;

NotifCourriel.ScrollBox = styled.div`
    height: 250px;
    overflow-y: scroll;
    background-color: ${colors.white};
    border-style: ridge;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
`;

NotifCourriel.SubHeaderTitle = styled.span`
    color : ${props => props.disabled ? colors.gray6C  : colors.black};
`;

export default NotifCourriel;
